<template>
	<div v-if="isViewOnly || me" class="comment-list">
		<CommentAction
			v-for="comment in commentsList"
			:key="comment?.id"
			:is-view-only="isViewOnly"
			class="mb-2"
			:comment="comment"
			:users="users"
			:project-share-users="projectShareUsers"
			:me="me"
			:is-comment-being-edited="isCommentBeingEdited"
			:light-box-view="lightBoxView"
			:user-map="userMap"
			@edit-comment="editComment"
			@update-comment="updateComment"
			@toggle-reply-box="toggleReplyBox"
			@delete-comment="deleteComment"
			@show-lucky="showLucky"
			@hide-lucky="hideLucky"
			@comment-edited="onCommentEdited"
			@reduce-comment-count="reduceCommentCount" />
		<div v-if="allowMore && !expandedComment" class="d-flex justify-center">
			<v-btn size="large" rounded="pill" color="#fff" class="border-btn mb-1" width="11rem" @click="loadMoreComments"
				>Load More</v-btn
			>
		</div>
	</div>
</template>

<script>
	import CommentAction from "./CommentAction.vue";
	export default {
		name: "CommentsList",
		components: {
			CommentAction
		},
		props: {
			comments: {
				type: Array,
				required: true
			},
			isViewOnly: {
				type: Boolean,
				required: true
			},
			lightBoxView: {
				type: Boolean,
				required: true
			},
			allowMore: {
				type: Boolean,
				required: true
			},
			projectShareUsers: {
				type: Array,
				default: () => []
			},
			users: {
				type: Array,
				default: () => [],
				required: true
			},
			me: {
				type: Object,
				required: false
			}
		},
		data() {
			return {
				expandedComment: null,
				isCommentBeingEdited: null
			};
		},
		computed: {
			commentsList() {
				if (this.expandedComment) {
					return [this.comments.find((comment) => comment?.id === this.expandedComment)];
				}
				return this.comments.filter((comment) => comment.deletedAt === null || comment.replyCount > 0);
			},
			userMap() {
				return new Map([...this.users, ...this.projectShareUsers].map((user) => [user.id, user.name]));
			}
		},
		watch: {
			comments: {
				handler() {},
				deep: true
			}
		},
		methods: {
			loadMoreComments() {
				this.$emit("load-more-comments");
			},
			reduceCommentCount() {
				this.$emit("reduce-comment-count");
			},
			editComment(comment, isEditing) {
				this.isCommentBeingEdited = isEditing;
				this.$emit("edit-comment", comment, isEditing);
			},
			updateComment(comment) {
				this.$emit("update-comment", comment);
			},
			toggleReplyBox(isOpen, commentId) {
				if (isOpen) {
					this.expandedComment = commentId;
				} else {
					this.expandedComment = null;
				}
				this.$emit("toggle-reply-box", isOpen, commentId);
			},
			deleteComment(commentId) {
				this.$emit("delete-comment", commentId);
			},
			hideLucky() {
				this.$emit("hide-lucky");
			},
			showLucky() {
				this.$emit("show-lucky");
			},
			onCommentEdited(editedComment) {
				this.$emit("comment-edited", editedComment);
			}
		}
	};
</script>
<style scoped>
	.comment-list {
		height: 100%;
	}
</style>
